import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TutorialRoutes } from "./tutorial.routing";
import { TutorialService } from "./services/tutorial.service";
import { TutorialResolver } from "./resolver/tutorial.resolver";
import { TutorialListComponent } from "./components/tutorial-list/tutorial-list.component";
import { SharedModule } from "src/app/shared/shared.module";
import { TutorialMaterialListComponent } from "./components/tutorial-material-list/tutorial-material-list.component";
import { TutorialEditComponent } from "./components/tutorial-edit/tutorial-edit.component";
import { TutorialItemArquivoComponent } from "./components/tutorial-item-arquivo/tutorial-item-arquivo.component";
import { TutorialItemComponent } from "./components/tutorial-item/tutorial-item.component";
import { TutorialEditColorComponent } from "./components/tutorial-edit-color/tutorial-edit-color.component";
import { TutorialMaterialEditComponent } from "./components/tutorial-material-edit/tutorial-material-edit.component";
import { TutorialMaterialService } from "./services/tutorial-class.service";
import { TutorialItemListComponent } from "./components/tutorial-item-list/tutorial-item-list.component";

@NgModule({
  imports: [
    TutorialRoutes,
    SharedModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    MatSlideToggleModule,
    PdfViewerModule
  ],
  exports: [
  ],
  declarations: [
    TutorialListComponent,
    TutorialMaterialListComponent,
    TutorialEditComponent,
    TutorialItemArquivoComponent,
    TutorialItemComponent,
    TutorialEditColorComponent,
    TutorialMaterialEditComponent,
    TutorialItemListComponent
  ],
  providers: [
    TutorialService,
    TutorialResolver,
    TutorialMaterialService
   ],
})
export class TutorialModule { }
